<!--  -->
<template>
  <div class="">
    <input type="file" style="width: 100px; height: 50px; background: #333" />
    <!-- <Button @click="onTap">点击</Button> -->
  </div>
</template>

<script>
// import { get } from "@/utils/request";
// import { api } from "@/utils/env";
// import BigNumber from "bignumber.js";
import { isBangBangApp, isAndroid, isIOS } from "@/utils/index";
import { Button } from "vant";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Button,
  },
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onTap() {
      if (isBangBangApp()) {
        if (isAndroid()) {
          window.synopsis.onShowFileChooser("");
          return;
        }
        if (isIOS()) {
          window.webkit.messageHandlers.onShowFileChooser.postMessage("");
        }
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // get({
    //   url: api + "face/h5Url",
    //   data: {},
    // })
    //   .then((data) => {
    //     if (data.result === "success") {
    //       location.href = data.body.h5Url;
    //     } else {
    //       // Toast(data.message);
    //     }
    //   })
    //   .catch(() => {});
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>